import React, { useCallback, useState } from 'react';

import { Divider } from '@material-ui/core';

import { RichTextEditor, Select, TextInput } from '../EditorFormElements';
import { Collapsible, FormFieldWrapper } from '../Global';
import { Stepper } from '../Interface';
import { CustomFeedback } from '../PracticeComponents';
import { Path, PathChoice, Story } from '.';

import { answerChoiceFormatOptions } from '../../config/simulation';



export const SimulationStepper = React.memo(({given={}, ...props}) => {

  const [format,setFormat] = useState('')
  const [pathNames,setPathNames] = useState([])

  const renderPathChoices = () =>  {
    if (!format) {
      return '';
    }
    const givenChoices = given.task && given.task.question && given.task.question.choices ? given.task.question.choices : [];

    let choices = [];
    for (let i = 0; i < parseInt(props.numPaths); i++) {
      choices.push(
        <PathChoice
          key={i}
          format={format}
          index={i}
          callback={onPathChoiceChange}
          given={givenChoices[i]}
          path="task,question,choices"
        />
      )
    }
    return choices;
  }

  const onFormatChange = useCallback((name,value) => {
    setFormat(value);
    setPathNames([]);
  }, [setFormat, setPathNames])


  const onPathChoiceChange = useCallback((index,value) => {
    setPathNames(oldPathNames => {
      const newPathNames = [...oldPathNames] 
      newPathNames[index] = value;
      return newPathNames;
    })
  }, [setPathNames])

  const mission = {
    label: "Mission",
    icon: <i className="far fa-star"></i>,
    content: <>
              <Collapsible title="Mission Story">
                <Story name="mission" label="Mission" given={given.mission} />
              </Collapsible>

              <Collapsible title="Mission Objectives">
                
                <FormFieldWrapper>

                  <TextInput
                    label="Objectives Lead-in"
                    name="leadin"
                    given={given.objectives ? given.objectives.leadin : null}
                    path="objectives"
                    validationCriteria={{
                      optional:true,
                    }}
                    help="This field is optional."
                  />

                  <RichTextEditor
                    name="items"
                    label="Objectives List"
                    defaultValue="<ol><li>Objective 1</li><li>Objective 2</li></ol>"
                    controls={['numberList']}
                    inlineToolbarControls={false}
                    disallowIndent
                    given={given.objectives ? given.objectives.items : null}
                    path="objectives"
                  />

                </FormFieldWrapper>

              </Collapsible>

              {props.numPaths > 1 ?
                <Collapsible title="Choose Your Path Question">
                  <FormFieldWrapper>
                    <TextInput 
                      label="Question Background Text"
                      multiline={true}
                      rows={4}
                      placeholder="Provide the background information needed to answer the question."
                      name="background"
                      path="task,question"
                      given={given.task && given.task.question ? given.task.question.background : null}
                    />

                    <TextInput 
                      label="Question Text"
                      multiline={true}
                      rows={3}
                      placeholder="Provide the question the user needs to answer."
                      name="text"
                      path="task,question"
                      given={given.task && given.task.question ? given.task.question.text : null}
                    />

                    <Select
                      label="Answer Choices Format"
                      name='format'
                      options={answerChoiceFormatOptions}
                      callback={onFormatChange}
                      help="If changed, you will lose content provided for other answer choices."
                      path="task,question"
                      given={given.task && given.task.question ? given.task.question.format : null}
                    />
                  </FormFieldWrapper>

                  <Divider />

                  {renderPathChoices()}

                </Collapsible>
              : '' }
            </>
  }


  const wrapUp = {
    label: "Wrap Up",
    icon: <i className="far fa-flag"></i>,
    content: <>
      <Collapsible title="Story Wrap Up">
        <Story name="debrief" label="Debrief" given={given.debrief}/>
      </Collapsible>
  
      <Collapsible title="Score Feedback">
        <CustomFeedback
          hideHeader
          given={given.responses}
        />
      </Collapsible>
    </>
  }

  let steps = [mission];
  
  for (let i = 0; i < parseInt(props.numPaths); i++) {
    steps.push({
      label: "Path " + (i + 1),
      icon: <span>{i + 1}</span>,
      content: <Path
                index={i}
                numPaths={props.numPaths}
                title={pathNames ? pathNames[i] : null}
                given={given.task && given.task.paths ? given.task.paths[i] : {}}
                path="task,paths"
              />
    })
  }

  steps.push(wrapUp);
  
  return (
    <Stepper steps={steps} />
  )
})